export default __webpack_public_path__ + "static/media/Upload button.d12af704.png";